import Api from '@/api/api'

/* All the Application related calls can be put here */
export default {
    getInitialData() {
        return Promise.all(
            [
                Api.get('/SaasAdmin/api/TenantConfig/Tenant'),
                Api.get('/SaasAdmin/api/SharedConfigurationProfile'), //TODO,
                Api.get('/SaasAdmin/Vendor/GetVendors'),
                Api.get('/SaasAdmin/api/Client/Client')
                //Promise.resolve({ data: [{ "id": 8, "name": "swwwwwwwwwwfdfsdfws", "description": "testssdesc4", "isDefault": false, "isSharedDb": true, "configDBDetail": [{ "id": 5, "configProfileID": 8, "microserviceName": "Team", "connectionString": "testservernamre" }, { "id": 6, "configProfileID": 8, "microserviceName": "Roaster", "connectionString": "testservernamre" }, { "id": 7, "configProfileID": 8, "microserviceName": "User", "connectionString": "testservernamre" }, { "id": 8, "configProfileID": 8, "microserviceName": "Driver", "connectionString": "testservernamre" }, { "id": 9, "configProfileID": 8, "microserviceName": "Trip", "connectionString": "testservernamre" }, { "id": 10, "configProfileID": 8, "microserviceName": "Adhoc", "connectionString": "testservernamre" }] }] })
            ]
        )
    },
    // getMenu() {
    //     const data = [
    //         {
    //             "id": 1,
    //             "tenantID": 1,
    //             "menuName": "Dashboard",
    //             "url": "/dashboard",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-browser-fill",
    //             "isVisible": true
    //         }, {
    //             "id": 9,
    //             "tenantID": 1,
    //             "menuName": "User Management",
    //             "url": "/user-management",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-person-fill",
    //             "isVisible": true
    //         },
    //         {
    //             "id": 10,
    //             "tenantID": 1,
    //             "menuName": "Zone Management",
    //             "url": "/zone-management",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-radio-button-on-fill",
    //             "isVisible": true
    //         },
    //         {
    //             "id": 6,
    //             "tenantID": 1,
    //             "menuName": "Product Configuration",
    //             "url": "/product-config",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-layers",
    //             "isVisible": true
    //         }, {
    //             "id": 7,
    //             "tenantID": 1,
    //             "menuName": "Package Configuration",
    //             "url": "/package-config",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-pantone",
    //             "isVisible": true
    //         }, {

    //             "id": 12,
    //             "tenantID": 1,
    //             "menuName": "Feature Configuration",
    //             "url": "/feature-config",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-options-2",
    //             "isVisible": true
    //         },
    //         {
    //             "id": 11,
    //             "tenantID": 1,
    //             "menuName": "Module Configuration",
    //             "url": "/package",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-copy",
    //             "isVisible": true
    //         },
    //         {
    //             "id": 2,
    //             "tenantID": 1,
    //             "menuName": "Vehicle Type",
    //             "url": "/vehicle-type",
    //             "parentID": null,
    //             "subMenu": [],
    //             "menuOrder": 0,
    //             "menuIcon": "nt-flash",
    //             "isVisible": true
    //         },
    //     ];
    //     return { data }
    // },
    getMenu() {
        return Api.get('/SaasAdmin/api/Menu/TenantMenu')
    },
    getTenants() {
        return Api.get('/SaasAdmin/api/TenantConfig/Tenant')
    },
    getClients() {
        return Api.get('/SaasAdmin/api/Client/Client')
    },
    getRoles() {
        return Api.get('SaasAdmin/api/TenantConfig/TenantUserRoles')
    }
}